import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

import { useBanner } from './BannerProvider';

function DomainMigrationBanner() {
  const { visible, close } = useBanner();
  const { t } = useTranslation('translation');

  if (!visible) {
    return null;
  }

  return (
    <Alert severity="warning" role="status" onClose={close}>
      {t('domain migration warning')}
    </Alert>
  );
}

export default DomainMigrationBanner;
